export enum EnumShortCuts {
  ABRIRCANCELAR = 'ABRIRCANCELAR',
  GUARDAR = 'GUARDAR',
  DESHACER = 'DESHACER',
  REHACER = 'REHACER',
  DESCARTAR = 'DESCARTAR',
  MARCARTODOS = 'MARCARTODOS'
}
